export default __webpack_public_path__ + "static/media/Microwave-Category-Offer.a5b17087.png";